import { defineMessages } from '@edx/frontend-platform/i18n';

export default defineMessages({
  blockFailed: {
    id: 'authoring.pdfEditor.blockFailed',
    defaultMessage: 'PDF block failed to load',
    description: 'Error message for PDF block failing to load',
  },
  blockLoading: {
    id: 'authoring.pdfEditor.blockLoading',
    defaultMessage: 'Loading PDF Editor',
    description: 'Message shown to screen readers when the PDF block is loading.',
  },
  urlFieldLabel: {
    id: 'authoring.pdfEditor.urlFieldLabel',
    defaultMessage: 'File',
    description: 'Label for the PDF URL field',
  },
});
